import { useCallback, useEffect, useState } from 'react';
import Style from "./style.module.css";
import XCloseIcon from '../../icons/x-close';
import { useApiCall } from '../../custom-hooks/api-call';
import LeftSidePopupLayout from '../../popup/modal-layout';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import GripVerticalIcon from '../../icons/grip-vertical';

const CustomizeTabsPopup = ({ onClose, onSave, onPreview, data, apiUrl, onPreviewClose }) => {
  const apiCall = useApiCall();
  const [datas, setData] = useState(data);

  const handleToggle = (key) => {
    const updated = datas.map(item =>
      item.key === key ? { ...item, is_visible: item.is_visible ? 0 : 1 } : item
    );
    setData(updated);
  };

  const [status, setStatus] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setStatus(true)
    }, 200)
  }, []);

  const closeFun = () => {
    setStatus(false)
    setTimeout(() => {
      onClose();
    }, 100)
  }

  const reOpen = () => {
    setStatus(true);
    onPreviewClose();
  }

  const saveFun = (datas, apiUrl, url = "save-user-headers") => {
    const nData = {
      "api_url": apiUrl,
      "headers": datas
    }
    apiCall({ url: url, method: 'post', data: nData }).then((res) => {
      onSave(datas);
    }).catch((error) => {
      console.error("Err", error)
    })
  }

  const [grabOffset, setGrabOffset] = useState({ x: 0, y: 0 });

  const onBeforeCapture = useCallback((start) => {
    // optional, can be left empty
  }, []);

  const onDragStart = useCallback((start, provided) => {
    const element = document.querySelector(`[data-rbd-draggable-id="${start.draggableId}"]`);
    if (element) {
      const rect = element.getBoundingClientRect();
      setGrabOffset({
        x: start.clientX - rect.left,
        y: start.clientY - rect.top
      });
    }
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(datas);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setData(reordered);
  };

  return (
    <LeftSidePopupLayout onClose={() => { (status) ? closeFun() : reOpen(); }} popupStatus={status} className={Style.customize_table_modal}>
      <div className={Style.modal_header}>
        <h4>Customize Table</h4>
        <button onClick={closeFun} className={Style.close_btn}><XCloseIcon /></button>
      </div>

      {/* <div className={Style.modal_body}> */}
      <DragDropContext
        className={Style.modal_body}
        onBeforeCapture={onBeforeCapture}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
      >
        <Droppable droppableId="toggleList">
          {(provided) => (
            <div
              className={Style.modal_body}
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {datas.map((tab, idx) => {
                if (tab?.show === 0) {
                  return;
                } else {
                  return (
                    <Draggable key={tab.key} draggableId={tab.key} index={idx}>
                      {(provided, snapshot) => {
                        const style = {
                          ...provided.draggableProps.style,
                          boxSizing: "border-box",
                          width: snapshot.isDragging ? provided.draggableProps.style.width || "100%" : "100%",
                        };

                        if ((snapshot.isDragging || snapshot.isDropAnimating) && style.transform) {
                          const match = style.transform.match(/translate(?:3d)?\(([^,]+)px,\s*([^,]+)px/);
                          if (match) {
                            let [, x, y] = match;
                            x = 0;
                            y = parseFloat(y) - grabOffset.y;
                            style.transform = `translate(${x}px, ${y}px)`;
                            style.left = "auto";
                          }
                        }

                        return (
                          <div
                            className={`${Style.tab_toggle} ${snapshot.isDragging ? Style.dragging : ""}`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={style}
                          >
                            <label className={Style.switch}>
                              <input
                                type="checkbox"
                                checked={tab.is_visible === 1}
                                onChange={() => handleToggle(tab.key)}
                              />
                              <span className={`${Style.slider} ${Style.round}`}>
                                <div className={Style.sliderCenterCircle}></div>
                              </span>
                            </label>

                            <div className={Style.cont}>
                              <span>{tab?.value}</span>
                              <div className={Style.dragHandle} {...provided.dragHandleProps}>
                                <GripVerticalIcon className={Style.dragIcon} />
                              </div>
                            </div>
                          </div>
                        );
                      }}
                    </Draggable>
                  )
                }
              })}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {/* </div> */}

      <div className={Style.modal_footer}>
        <button className={`${Style.btn} ${Style.outline} opacity-0 pointer-events-none`} onClick={() => {
          onPreview(datas);
          setStatus(false)
          // closeFun();
        }}>
          Table Preview
        </button>

        <button className={Style.btn} onClick={() => {
          saveFun(datas, apiUrl);
          closeFun();
        }}>
          Table Save
        </button>
      </div>
    </LeftSidePopupLayout>
  );
};

export default CustomizeTabsPopup;
